import { Flex } from "@chakra-ui/react";
import BadgeButton from "components/BadgeButton";
import OutlineButton from "components/Button/OutlineButton";
import colors from "core/resources/theme/colors";
import { MdFilterList } from "react-icons/md";

interface FiltrosHeaderTableProps {
  onFiltro: () => void;
  badge?: boolean;
  badgeValue?: number;
}

export default function FiltrosHeaderTable({
  badge,
  badgeValue,
  onFiltro,
}: FiltrosHeaderTableProps) {
  return (
    <Flex>
      <Flex ml="auto" justifyContent="end" onClick={onFiltro}>
        <OutlineButton
          position="relative"
          size="sm"
          fontSize={12}
          fontWeight="normal"
          lineColor={colors.black}
          rounded={20}
        >
          <MdFilterList size={20} color={colors.primary} />
          Mais filtros
        </OutlineButton>
        {badge && badgeValue ? <BadgeButton badgeValue={badgeValue} /> : null}
      </Flex>
    </Flex>
  );
}
